// Modules
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

// Components
import { HomeComponent, KeepSessionAliveComponent, MemberPortalLogoutComponent, PageNotFoundComponent, PortalCloseComponent,
  SsoLandingComponent, SsoLoginComponent, UnauthorizedComponent } from './shared/components';

// Guards
import { AuthorizationGuard } from './shared/guards/authorization/authorization.guard';

// Routes
const routes: Routes = [
  { path: 'ssolanding', component: SsoLandingComponent },
  { path: 'unauthorized', component: UnauthorizedComponent },
  { path: 'unauthorized/:status', component: UnauthorizedComponent },
  { path: 'pagenotfound', component: PageNotFoundComponent },
  { path: 'keepsessionalive', component: KeepSessionAliveComponent},
  { path: 'logout', component: MemberPortalLogoutComponent },
  { path: 'close', component: PortalCloseComponent},
  { path: '', canActivate: [AuthorizationGuard], children: [
    { path: '', component: HomeComponent },
    { path: 'home', component: HomeComponent },
    { path: 'keepsessionalive', component: KeepSessionAliveComponent},
    { path: 'callback', loadChildren: './authorization.module#AuthorizationModule' },
    { path: 'admin', loadChildren: () => import('./admin/admin.module').then(m => m.AdminModule) },
    { path: 'member', loadChildren: () => import('./member/member.module').then(m => m.MemberModule) },
    { path: 'ssologin', component: SsoLoginComponent },
    { path: 'pagenotfound', component: PageNotFoundComponent },
    { path: '**', redirectTo: 'pagenotfound', pathMatch: 'full' }
  ]},
  { path: '**', redirectTo: 'pagenotfound', pathMatch: 'full' }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes)
  ],
  exports: [
    RouterModule
  ]
})
export class AppRoutingModule { }
